const reviewSwiper = document.querySelector('.js-reviews')

const reviewSwiperInit = new Swiper(reviewSwiper, {
  loop: false,
  spaceBetween: 0,
  grabCursor: true,
  slidesPerView: 1,
  breakpoints: {
    720: {
      slidesPerView: 2
    },
    1180: {
      slidesPerView: 3
    }
  },
  navigation: {
    nextEl: ".reviews-swiper-button-next",
    prevEl: ".reviews-swiper-button-prev",
  },
  pagination: {
    el: ".reviews-swiper-pagination",
    type: 'custom',
    renderCustom: function (swiper, current, total) {
      return ('0' + current).slice(-2) + ' | ' + ('0' + total).slice(-2);
    }
  }
});
